import { createSelector } from 'reselect'
import currentUserRolesSelector from 'selectors/currentUserRoles'

export const getMode = (state, props) => {
  return state['view-home'].users.mode
}

export const getKeyword = (state, props) => {
  return state['view-home'].users.keyword
}

export const getUsers = (state, props) => {
  return state['view-home'].users.users
}

export const getUsersById = (state, props) => {
  return state['view-home'].users.usersById
}

export const getKanBoUsers = (state, props) => {
  return state.kanbo.users
}

export const usersSelector = createSelector(
  [getUsers, getUsersById, getKanBoUsers],
  (users, usersById, kanBoUsers) => {
    return users.map(id => ({
      ...usersById[id],
      ...kanBoUsers[id]
    }))
  }
)

export const getLoading = (state, props) => {
  return state['view-home'].users.loading
}

export const getLoaded = (state, props) => {
  return state['view-home'].users.loaded
}

export const getLastLoadedId = (state, props) => {
  return state['view-home'].users.lastLoadedActiveId
}

const getIsOffice365 = state => state.kanbo.config.isOffice365

export default createSelector(
  [
    currentUserRolesSelector,
    getMode,
    getKeyword,
    usersSelector,
    getLoading,
    getLoaded,
    getLastLoadedId,
    getIsOffice365,
  ],
  (
    currentUserRoles,
    mode,
    keyword,
    users,
    loading,
    loaded,
    lastLoadedId,
    isOffice365,
  ) => ({
    currentUserRoles,
    mode,
    keyword,
    users,
    loading,
    loaded,
    lastLoadedId,
    isOffice365,
  })
)
